import { Checkbox } from "antd";
import styled from "styled-components";

// The shapefile group row's chrome (border/dividers, checkbox+swatch column,
// label column, row height), extracted so the rig/frac value list can render
// the exact same row by construction instead of hand-copied CSS. Kept as a
// standalone module (not imported straight from ShapefileFeatureGroup.tsx) so
// consumers don't pull in that file's heavier import graph — mutations, map
// utils, toast — just to get these styled primitives.
//
// ShapefileFeatureGroup.tsx imports these too, so both panels share the same
// component instances; changes here affect both and should be made carefully.

export const ITEM_HEIGHT = 35;

export const CustomExpanderRoot = styled.div`
  padding: 5px;
  background-color: #fff;
  margin-bottom: 16px;
  border: 1px solid #d9d9d9;
  border-bottom: 0;
  min-height: fit-content;

  &:last-child {
    border-bottom: 1px solid #d9d9d9;
  }

  .ant-card {
    margin-top: 10px;
  }

  .ant-card {
    border: none;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    padding: 5px 0;
    margin-top: 5px;
    border-radius: 0;
  }

  .ant-card-body {
    padding: 0px 20px;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 6px;
`;

export const TitleContainer = styled.div`
  width: 100%;
`;

export const GroupedFeatureHeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
`;

export const StyledCheckbox = styled(Checkbox)`
  padding-right: 4px;

  /* ant-checkbox - Unsure of cause, but without this, there is as an overflow which creates an 'invisible' scrollbar */
  /* Could be inherited styles from the antd panel */

  .ant-checkbox-checked {
    overflow: hidden;
  }
`;

export const StyledGeomGroupTitle = styled.span`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: default;

  /* ant-checkbox - Not perfect solution, but full width will cut into checkbox width,
   * and making checkbox width 100% takes up too much width probably because of the hidden styles */
  width: 78%;
`;

export const ChevronContainer = styled.div<{ isOpen: boolean }>`
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transform: ${({ isOpen }) => (isOpen ? "rotate(360deg)" : "rotate(270deg)")};
  transition: all 0.2s;

  &:hover {
    color: var(--color-primary);
  }
`;
